// extracted by mini-css-extract-plugin
export default {"row":"CriteriaRow_row__hPhjt","actions":"CriteriaRow_actions__iTIye","limitedText":"CriteriaRow_limitedText__mVYKD","criteriaType":"CriteriaRow_criteriaType__a-nPF"};